<form [formGroup]="form" (ngSubmit)="save()">
  <div class="col-xxl-12 col-lg-12 col-md-12 col-sm-12 d-grid gap-4 p-4 bg-white rounded-3">
    <div class="d-grid gap-2">
      <h3 class="fw-bold">Hình thức kinh doanh</h3>
      <div>
        <div class="form-floating">
          <select
            class="form-control ng-untouched ng-pristine ng-invalid"
            id="businessType"
            aria-label="Default select example"
            formControlName="businessType"
            placeholder="Lựa chọn hình thức kinh doanh">
            <option value="" disabled selected>Lựa chọn hình thức kinh doanh</option>
            <ng-container *ngFor="let business of formOfBusinesses">
              <option value="{{ business.code }}" [selected]="business.code == selectedBusinessType">
                {{ business.name }}
              </option>
            </ng-container>
          </select>
          <label for="businessType">
            Chọn hình thức kinh doanh
            <span style="color: #dd0000">* </span>
          </label>
          <!--
          <input
            type="text"
            class="form-control"
            id="businessType"
            required
            formControlName="businessType"
          />
          <label for="businessType">
            Chọn hình thức kinh doanh
            <span style="color: #dd0000">* </span>
          </label> -->
        </div>
        <label
          *ngIf="form.controls['businessType'].touched && form.controls['businessType'].errors?.['required']"
          class="invalid-feedback">
          Chọn hình thức kinh doanh
        </label>
      </div>
    </div>
    <div class="d-grid gap-2">
      <h3 class="fw-bold">Thông tin cơ sở kinh doanh</h3>
      <div class="d-flex row">
        <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="businessName"
              required
              formControlName="businessName"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label for="businessName">
              Tên cơ sở kinh doanh
              <span style="color: #dd0000">* </span>
            </label>
          </div>
          <label
            *ngIf="form.controls['businessName'].touched && form.controls['businessName'].errors?.['required']"
            class="invalid-feedback">
            Nhập tên cơ sở kinh doanh
          </label>
        </div>
        <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="taxCode"
              formControlName="taxCode"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label for="taxCode">Mã số thuế </label>
          </div>
        </div>
      </div>
      <ng-container *ngIf="isAddressV2; else addressV1">
        <div class="d-flex row">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
            <div class="form-floating">
              <select2
                class="form-control form-select select2"
                id="province"
                aria-label="Default select example"
                placeholder="Tỉnh/Thành phố *"
                [data]="select2ProvinceV2"
                formControlName="province">
              </select2>
              <label for="province">
                Chọn Tỉnh/Thành phố
                <span style="color: #dd0000">* </span>
              </label>
            </div>
          </div>
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6">
            <div class="form-floating">
              <select2
                class="form-control form-select select2"
                id="ward"
                aria-label="Default select example"
                placeholder="Phường Xã *"
                [data]="select2WardsV2"
                [value]="selectedWard"
                formControlName="ward">
              </select2>
              <label for="ward">
                Chọn Phường/Xã
                <span style="color: #dd0000">* </span>
              </label>
            </div>
          </div>
        </div>
        <div class="d-flex gap-1">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
            <div class="form-floating">
              <input type="email" class="form-control" id="address" formControlName="address" readonly />
              <label for="address">Địa chỉ (số nhà, tên đường)</label>
            </div>
          </div>
        </div>
        <div class="d-flex gap-1">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
            <div class="form-floating">
              <input type="text" class="form-control" id="buyerName" formControlName="buyerName" />
              <label for="buyerName">Họ tên người mua hàng</label>
            </div>
          </div>
        </div>
        <label
          *ngIf="form.controls['buyerName'].touched && form.controls['buyerName'].errors?.['required']"
          class="invalid-feedback">
          Nhập họ tên người mua hàng
        </label>
        <div class="d-flex gap-1">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
            <div class="form-floating">
              <input
                type="text"
                class="form-control"
                id="budgetRelationShipCode"
                [maxlength]="budgetRelationShipCodeMaxLength"
                formControlName="budgetRelationShipCode" />
              <label for="budgetRelationShipCode">Mã quan hệ ngân sách</label>
            </div>
            <div class="text-end small text-muted">Còn {{ budgetRelationShipCodeRemaining }} ký tự</div>
          </div>
        </div>
        <label *ngIf="form.controls['budgetRelationShipCode'].errors?.['maxlength']" class="invalid-feedback">
          Mã quan hệ ngân sách tối đa {{ budgetRelationShipCodeMaxLength }} ký tự
        </label>
      </ng-container>
      <ng-template #addressV1>
        <div class="d-flex row">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
            <div class="form-floating">
              <!-- <select
              type="email"
              class="form-control"
              id="province"
              required
              formControlName="province"
              (change)="loadDistrictsByProvince($event)"
            >
              <option value="" disabled selected>Tỉnh/Thành phố *</option>
              <ng-container *ngFor="let province of provinces">
                <option
                  value="{{ province.code }}"
                  [selected]="province.code == selectedProvince"
                >
                  {{ province.name }}
                </option>
              </ng-container>
            </select> -->
              <select2
                class="form-control form-select select2"
                id="province"
                aria-label="Default select example"
                formControlName="province"
                (update)="loadDistrictsByProvince($event)"
                placeholder="Tỉnh/Thành phố *"
                [data]="select2Provinces">
              </select2>
              <label for="province">
                Chọn Tỉnh/Thành phố
                <span style="color: #dd0000">* </span>
              </label>
            </div>
            <label
              *ngIf="form.controls['province'].touched && form.controls['province'].errors?.['required']"
              class="invalid-feedback">
              Chọn Tỉnh/Thành phố
            </label>
          </div>
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 pb-2">
            <div class="form-floating">
              <!-- <select
              type="email"
              class="form-control"
              id="district"
              required
              formControlName="district"
              (change)="loadWardsByDistrict($event)"
            >
              <option value="" disabled selected>Quận Huyện</option>
              <ng-container *ngFor="let district of districts">
                <option
                  value="{{ district.code }}"
                  [selected]="district.code == selectedDistrict"
                >
                  {{ district.name }}
                </option>
              </ng-container>
            </select> -->
              <select2
                class="form-control form-select select2"
                id="district"
                aria-label="Default select example"
                formControlName="district"
                (update)="loadWardsByDistrict($event)"
                placeholder="Quận Huyện *"
                [data]="select2Districts">
              </select2>
              <label for="district">
                Chọn Quận/Huyện
                <span style="color: #dd0000">* </span>
              </label>
            </div>
            <label
              *ngIf="form.controls['district'].touched && form.controls['district'].errors?.['required']"
              class="invalid-feedback">
              Chọn Quận/Huyện
            </label>
          </div>
        </div>
        <div class="d-flex gap-1">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
            <div class="form-floating">
              <!-- <select
              type="email"
              class="form-control"
              id="ward"
              required
              formControlName="ward"
              (change)="selectWard($event)"
            >
              <option value="" disabled selected>Phường Xã</option>
              <ng-container *ngFor="let ward of wards">
                <option
                  value="{{ ward.code }}"
                  [selected]="ward.code == selectedWard"
                >
                  {{ ward.name }}
                </option>
              </ng-container>
            </select> -->
              <select2
                class="form-control form-select select2"
                id="ward"
                aria-label="Default select example"
                formControlName="ward"
                placeholder="Phường Xã *"
                [data]="select2Wards">
              </select2>
              <label for="ward">
                Chọn Phường/Xã
                <span style="color: #dd0000">* </span>
              </label>
            </div>
            <label
              *ngIf="form.controls['ward'].touched && form.controls['ward'].errors?.['required']"
              class="invalid-feedback">
              Chọn Phường/Xã
            </label>
          </div>
        </div>
        <div class="d-flex gap-1">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-6 w-100">
            <div class="form-floating">
              <input
                type="email"
                class="form-control"
                id="address"
                formControlName="address"
                readonly
                (keyup)="$event.preventDefault()"
                (keypress)="$event.preventDefault()"
                (keydown)="$event.preventDefault()"
                (paste)="$event.preventDefault()"
                (copy)="$event.preventDefault()"
                (cut)="$event.preventDefault()" />
              <label for="address">Địa chỉ (số nhà, tên đường)</label>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="d-grid gap-4">
      <h3 class="fw-bold">Giấy phép đăng ký kinh doanh</h3>
      <div class="d-flex row">
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating h-100">
            <input
              type="text"
              class="form-control h-100"
              id="businessLicensesNo"
              formControlName="businessLicensesNo"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label for="businessLicensesNo"> Số giấy phép </label>
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating h-100">
            <input
              class="form-control h-100"
              placeholder="Ngày cấp"
              name="dp1"
              style="width: -webkit-fill-available"
              formControlName="businessLicensesDate"
              readonly
              ngbDatepicker
              #ds1="ngbDatepicker"
              (click)="ds1.toggle()"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label class="date-picker-label" for="businessLicensesDate"> Ngày cấp </label>
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating">
            <textarea
              type="text"
              class="form-control"
              style="height: auto; resize: none"
              id="businessLicensesProvince"
              formControlName="businessLicensesProvince"
              rows="2"></textarea>
            <label for="businessLicensesProvince"> Nơi cấp </label>
          </div>
        </div>
      </div>
      <div *ngIf="this.businessLicensesImage; else uploadfile">
        <a href="{{ businessLicensesImage }}" target="_blank">
          <img
            src="{{ businessLicensesImage }}"
            alt="image"
            class="img-fluid"
            style="width: 100px; height: 100px"
            loading="lazy"
        /></a>
        <a href="javascript:void(0)" (click)="remove(0)"><i class="ri-close-line text-red"></i></a>
      </div>

      <ng-template #uploadfile>
        <app-file-upload
          [multipleFiles]="false"
          [files]="businessProfile.businessLicenses"
          [fileType]="allowedTypes.join(',')"
          [title]="'Nhấn tải lên giấy chứng nhận của bạn tại đây.'"
          [description]="'Định dạng PNG, JPEG, JPG, PDF dung lượng dưới 10MB'"
          (select)="onSelect($event, 0)"
          (remove)="onRemove($event, 0)"
          formControlName="businessLicenses"
          ngDefaultControl></app-file-upload>
      </ng-template>

      <label
        *ngIf="form.controls['businessLicenses'].touched && form.controls['businessLicenses'].errors?.['required']"
        class="invalid-feedback">
        Thêm giấy phép đăng ký kinh doanh
      </label>
    </div>
    <div class="d-grid gap-4">
      <h3 class="fw-bold">Giấy chứng nhận đủ điều kiện kinh doanh dược</h3>
      <div class="d-flex row">
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating h-100">
            <input
              type="text"
              class="form-control h-100"
              id="businessCertificationsNo"
              formControlName="businessCertificationsNo"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label for="businessCertificationsNo"> Số giấy phép </label>
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating h-100">
            <input
              class="form-control h-100"
              placeholder="Ngày cấp"
              name="dp2"
              style="width: -webkit-fill-available"
              formControlName="businessCertificationsDate"
              readonly
              ngbDatepicker
              #ds2="ngbDatepicker"
              (click)="ds2.toggle()"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label class="date-picker-label" for="businessCertificationsDate"> Ngày cấp </label>
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating">
            <textarea
              type="text"
              class="form-control"
              style="height: auto; resize: none"
              id="businessCertificationsProvince"
              formControlName="businessCertificationsProvince"
              rows="2"></textarea>
            <label for="businessCertificationsProvince"> Nơi cấp </label>
          </div>
        </div>
      </div>
      <div *ngIf="this.businessCertificationsImage; else uploadfileCert">
        <a href="{{ businessCertificationsImage }}" target="_blank">
          <img
            src="{{ businessCertificationsImage }}"
            alt="image"
            class="img-fluid"
            style="width: 100px; height: 100px"
            loading="lazy"
        /></a>
        <a href="javascript:void(0)" (click)="remove(1)"><i class="ri-close-line text-red"></i></a>
      </div>
      <ng-template #uploadfileCert>
        <app-file-upload
          [multipleFiles]="false"
          [files]="businessProfile.businessCertifications"
          [fileType]="allowedTypes.join(',')"
          [title]="'Nhấn tải lên giấy chứng nhận của bạn tại đây.'"
          [description]="'Định dạng PNG, JPEG, JPG, PDF dung lượng dưới 10MB'"
          (select)="onSelect($event, 1)"
          (remove)="onRemove($event, 1)"
          formControlName="businessCertifications"
          ngDefaultControl></app-file-upload>
      </ng-template>

      <label
        *ngIf="
          form.controls['businessCertifications'].touched &&
          form.controls['businessCertifications'].errors?.['required']
        "
        class="invalid-feedback">
        Thêm giấy chứng nhận đủ điều kiện kinh doanh dược
      </label>
    </div>
    <div class="d-grid gap-4">
      <h3 class="fw-bold">Giấy chứng nhận đạt thực hành tốt phân phối thuốc, nguyên liệu làm thuốc (GPP)</h3>
      <div class="d-flex row">
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="distributionCertificationsNo"
              formControlName="distributionCertificationsNo"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label for="distributionCertificationsNo"> Số giấy phép </label>
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating">
            <input
              class="form-control"
              placeholder="Ngày cấp"
              name="dp3"
              style="width: -webkit-fill-available"
              formControlName="distributionCertificationsDate"
              readonly
              ngbDatepicker
              #ds3="ngbDatepicker"
              (click)="ds3.toggle()"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label class="date-picker-label" for="distributionCertificationsDate"> Ngày cấp </label>
          </div>
        </div>
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating">
            <input
              class="form-control"
              placeholder="Ngày cấp"
              name="dp4"
              style="width: -webkit-fill-available"
              formControlName="distributionCertificationsExpirationDate"
              readonly
              ngbDatepicker
              (ngModelChange)="checkExpirationDate($event)"
              #ds4="ngbDatepicker"
              (click)="ds4.toggle()"
              readonly
              (keyup)="$event.preventDefault()"
              (keypress)="$event.preventDefault()"
              (keydown)="$event.preventDefault()"
              (paste)="$event.preventDefault()"
              (copy)="$event.preventDefault()"
              (cut)="$event.preventDefault()" />
            <label class="date-picker-label" for="distributionCertificationsExpirationDate"> Ngày hết hạn </label>
          </div>
          <label *ngIf="isExpiredDateWarning" class="invalid-feedback d-block">
            Lưu ý: Giấy chứng nhận GPP đã hết hạn hoặc sắp hết hạn.
          </label>
        </div>
      </div>
      <div class="d-flex row">
        <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
          <div class="form-floating">
            <textarea
              type="text"
              class="form-control"
              style="height: auto; resize: none"
              id="distributionCertificationsProvince"
              formControlName="distributionCertificationsProvince"
              rows="2"></textarea>
            <label for="distributionCertificationsProvince"> Nơi cấp </label>
          </div>
        </div>
      </div>
      <div *ngIf="this.distributionCertificationsImage; else uploadfileStandard">
        <a href="{{ distributionCertificationsImage }}" target="_blank">
          <img
            src="{{ distributionCertificationsImage }}"
            alt="image"
            class="img-fluid"
            style="width: 100px; height: 100px"
            loading="lazy"
        /></a>
        <a href="javascript:void(0)" (click)="remove(2)"><i class="ri-close-line text-red"></i></a>
      </div>
      <ng-template #uploadfileStandard>
        <app-file-upload
          [multipleFiles]="false"
          [files]="businessProfile.distributionCertifications"
          [fileType]="allowedTypes.join(',')"
          [title]="'Nhấn tải lên giấy chứng nhận của bạn tại đây.'"
          [description]="'Định dạng PNG, JPEG, JPG, PDF dung lượng dưới 10MB'"
          (select)="onSelect($event, 2)"
          (remove)="onRemove($event, 2)"
          formControlName="distributionCertifications"
          ngDefaultControl></app-file-upload>
      </ng-template>

      <label
        *ngIf="
          form.controls['distributionCertifications'].touched &&
          form.controls['distributionCertifications'].errors?.['required']
        "
        class="invalid-feedback">
        Thêm giấy chứng nhận đạt thực hành tốt phân phối thuốc, nguyên liệu làm thuốc
      </label>
    </div>
    <div>
      <h3 class="fw-bold">Danh mục sản phẩm được phép kinh doanh</h3>
      <div class="row row-cols-2 row-cols-lg-2 row-cols-md-3 row-cols-xl-3 row-cols-xxl-4 g-3 g-sm-4 pt-3">
        <div *ngFor="let scope of businessScopes" class="d-flex align-items-center" style="opacity: 0.6">
          <input
            class="checkbox_animated"
            type="checkbox"
            id="category-{{ scope.code }}"
            (click)="selectScope(scope)"
            [checked]="scope.checked"
            disabled
            readonly
            (keyup)="$event.preventDefault()"
            (keypress)="$event.preventDefault()"
            (keydown)="$event.preventDefault()"
            (paste)="$event.preventDefault()"
            (copy)="$event.preventDefault()"
            (cut)="$event.preventDefault()" />
          <label class="form-check-label" for="category-{{ scope.code }}">
            <span class="name">{{ scope.name }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center pt-5">
      <div class="col-xxl-4 col-md-4 col-lg-4 col-sm-4">
        <button type="submit" class="btn save-button">Yêu cầu phê duyệt hồ sơ</button>
      </div>
    </div>
  </div>
</form>

<app-business-registration-certificate
  #businessRegistrationCertificateModal
  [user]="user"
  [files]="businessProfile.businessLicenses"
  [fileType]="fileType"
  (confirmForm)="onConfirmForm($event, 0)"
  (closeForm)="onCloseForm(0)"></app-business-registration-certificate>

<app-business-registration-certificate-2
  #businessRegistrationCertificateModal2
  [select2Provinces]="select2Provinces"
  [user]="user"
  [files]="businessProfile.businessCertifications"
  [fileType]="fileType"
  (confirmForm)="onConfirmForm($event, 1)"
  (closeForm)="onCloseForm(1)"></app-business-registration-certificate-2>

<app-pharmaceutical-standard
  #pharmaceuticalStandardModal
  [businessScopes]="businessScopes"
  [user]="user"
  [files]="businessProfile.distributionCertifications"
  [fileType]="fileType"
  (confirmForm)="onConfirmForm($event, 2)"
  (closeForm)="onCloseForm(2)"></app-pharmaceutical-standard>

<app-confirmation-modal
  #confirmationModal
  [title]="'Xác nhận thông tin'"
  [message]="'Tài khoản sẽ bị chuyển sang trạng thái chờ duyệt và Các đơn hàng sẽ được xử lý sau khi Tài khoản được chuyển sang trạng thái đã duyệt'"
  (confirmed)="onConfirm($event)"></app-confirmation-modal>
